import React from "react";
import { commaFormatted } from "../../../libs/estrylib/Functions";

export const NumberItemElement = ({
  icon,
  numberItemTitle,
  number,
  currencySymbol,
  isPercentage,
  onClick = () => {},
  lang,
}) => {
  let numberItemTitleStyle = {
    color: "#199B8B",
    marginLeft: "0.71rem",
  };
  let currencySymbolStyle = { marginLeft: "0.4375rem" };
  if (lang === "ar") {
    currencySymbolStyle = { marginRight: "0.4375rem" };
    numberItemTitleStyle = {
      color: "#199B8B",
      marginRight: "0.71rem",
    };
  }
  return (
    <div className="col-6 col-sm-3 number-item-button" onClick={onClick}>
      <div
        className="clickable"
        style={{
          paddingTop: "1.25rem",
          paddingBottom: "1.25rem",
          paddingRight: "1.1rem",
          paddingLeft: "1.1rem",
          backgroundColor: "white",
          borderRadius: "20px",
        }}
      >
        <div className="d-flex align-items-center justify-content-start">
          <span className="icon">{icon}</span>
          <span
            className="title inter-semi-bold font-size-1"
            style={numberItemTitleStyle}
          >
            {numberItemTitle}
          </span>
        </div>
        <div className="d-flex align-items-center justify-content-start">
          <span className="number inter-bold font-size-1">{number}</span>
          {isPercentage ? (
            <span className="inter-bold font-size-1">%</span>
          ) : (
            <span className="currency-symbol" style={currencySymbolStyle}>
              {currencySymbol}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};
